import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/toxicology/organic-impurities-reports")({
  beforeLoad: () => { throw redirect({ href: "/zh-cn/services/regulatory-toxicology/organic-impurities-reports", statusCode: 301 }); },
});
